
import Swiper, { Navigation, Pagination } from 'swiper';
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import MicroModal from 'micromodal';
import { initLogoStrip } from './modules/logoStrip.js';
import { initAmenitiesSlider } from './modules/amenitiesSlider.js';
import AOS from 'aos';

function init() {

  MicroModal.init({
    openClass: 'is-open', // [5]
    disableScroll: true, // [6]
    disableFocus: false, // [7]
    awaitOpenAnimation: true, // [8]
    awaitCloseAnimation: true // [9]
  });

  window.Alpine = Alpine;
  Alpine.plugin(collapse)
  Alpine.start();

  AOS.init({disable: 'mobile'});


  const logoStrip = initLogoStrip('.logo-strip');
  const amenitiesSlider = initAmenitiesSlider('.amenities-slider');

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();

      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      const offset = 50;

      if (targetElement) {
        const elementPosition = targetElement.offsetTop;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });

        // Update URL hash
        history.pushState(null, null, `#${targetId}`);
      }
    });
  });


}


window.addEventListener("DOMContentLoaded", function () {
  init(); //
  // window.Fancybox = Fancybox;

});
